astJQuery(document).ready(function ($) {
                
    const element = document.getElementById('gt-asterio-panier');
    const options = asterioVars;
    console.log(options);
    
    $("#be-messages").ModuleMessage({
        kmlCode: KML_CODE,
        templateCode: TEMPLATE_CODE,
    });

    $(element).ModuleCart({
        kmlCode: KML_CODE,
        templateCode: TEMPLATE_CODE,
        messageHandler: $("#be-messages"),
        validateCart: false,
        modifyCart:true,
        showAddToCartPopup:false,
        popupOptions: {
            modal: true,
            dialogClass: 'visible-dialog-close-button-on-mobile dialog-as-panel full_screen_on_mobile'
        },
        finalizeCartUrl: options.cart_details_page + "?_ast_page=details",
        addToCartRedirectUrl: options.cart_details_page + "?_ast_page=details",
        giftVoucherEditionRedirectionUrl: options.gifts_page + "?gt_checkout=2",
        restaurantReservationEditionRedirUrl: options.restaurant_page,
        popupDisplay: true,
        showAddToCartPopup: true,
        avoidBodyScrollWhenDialogOpened: false,
        'sqs.cartupdated': function (event, data) {
            alert('cart updated');
        },
        'sqs.cartValidated': function (event, data) {
            alert('cart updated');
        }
    });
});
